import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './styles.module.scss';

interface SortingOptionsProps {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onSortByChange: (sortBy: string) => void;
  onSortOrderChange: (order: 'asc' | 'desc') => void;
}

const SORT_OPTIONS = [
  { value: 'dueDate', label: 'Due Date' },
  { value: 'eventType', label: 'Event Type' },
  { value: 'documentName', label: 'Document Name' },
  { value: 'dealName', label: 'Deal Name' },
  { value: 'status', label: 'Status' },
];

export const SortingOptions: React.FC<SortingOptionsProps> = ({
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
}) => {
  return (
    <div className={styles.sortingSection}>
      <div className={styles.sortBySection}>
        <label className={styles.sectionLabel}>Sort By</label>
        {SORT_OPTIONS.map(({ value, label }) => (
          <Form.Check
            key={value}
            type="radio"
            id={`sort-by-${value}`}
            label={label}
            name="sortBy"
            checked={sortBy === value}
            onChange={() => onSortByChange(value)}
            className={styles.filterRadio}
          />
        ))}
      </div>
      
      <div className={styles.sortOrderSection}>
        <label className={styles.sectionLabel}>Order</label>
        <Form.Check
          type="radio"
          id="sort-order-asc"
          label="Ascending"
          name="sortOrder"
          checked={sortOrder === 'asc'}
          onChange={() => onSortOrderChange('asc')}
          className={styles.filterRadio}
        />
        <Form.Check
          type="radio"
          id="sort-order-desc"
          label="Descending"
          name="sortOrder"
          checked={sortOrder === 'desc'}
          onChange={() => onSortOrderChange('desc')}
          className={styles.filterRadio}
        />
      </div>
    </div>
  );
};